import { Component } from '@angular/core';
import { InstallationsService } from 'projects/c1-backend/src/app/services/installations.service';
import { Globals } from 'projects/core/src/globals';
import { Filter, FilterMode } from 'projects/core/src/include/structures';
import { ContractsDetailComponent } from '../../../contracts/contracts-detail/contracts-detail.component';
import { DocumentsDetailsComponent } from '../../../documents/documents-details/documents-details.component';
import { DocumentDetail, DocumentMode, DocumentsType } from 'projects/c1-backend/src/app/db/documents';
import { Installation } from 'projects/c1-backend/src/app/db/installation';
import { Contracts } from 'projects/c1-backend/src/app/db/contracts';
import { Address } from 'projects/c1-backend/src/app/db/address';
import { add } from 'mathjs';

@Component({
  selector: 'app-serials-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.css'
})
export class SerialsSearchComponent {
  
  constructor(    private installationsService: InstallationsService){

  }
  
  list:Installation[]=[];
  search_text="";



  search(){


    let  filter_search:Filter=new Filter();
    
    filter_search.mode=FilterMode.like;
    filter_search.fields=[];
    filter_search.fields.push("p.sn");
    filter_search.fields.push("p.matricola");
    filter_search.fields.push("p.code");
    filter_search.value=this.search_text;
    
    let filters:any=[];
    filters.push(filter_search)
    
    this.installationsService.getItems(filters,[]).subscribe((items:any)=>{
      this.search_text="";
      if(items.value.length>0){
        this.list.push(items.value[0]);
      }
    });

  }


  remove(i:number){
    this.list.splice(i,1);
    
  }
    openContract(contract:Contracts){
      Globals.modal.showModal(ContractsDetailComponent,[
        {"name":"mode","value":"modal"},
        {"name":"id","value":contract.id}
      ],()=>{
  
      });
    }


  reset(){
    this.list=[];
  }


  createDocumentInventory(){

    let toUnLoad:any[]=[];
    let address:any;
    for(let r of this.list){
      address=r.shop.addressItem;
      toUnLoad.push(
        {
          "id":0,
          "id_product":r.id_product,
          "code":r.sn,
          "sn":r.sn,
          "description":r.product.brand+" "+r.product.name,
          "quantity":1,
          "quantityPartial":0,
          "unit":r.product.unit,
          "netprice":0,
          "tax":0,
          "id_tax":0,
          "discount1":0,
          "discount2":0,
          "discount3":0,
          "percentual":0,
          "gross":0,
          "note":"",
          "weight":0,
          "product":r.product,
        }

      )
    }



    Globals.modal.showModal(DocumentsDetailsComponent,[
          {"name":"mode","value":"modal"},
          {"name":"id","value":0},
          {"name":"id_address","value":address?address.id:0},
          {"name":"details","value":toUnLoad},
          {"name":"address_shipping","value":Globals.defaultAddress},
          {"name":"causal","value":Globals.parameters.get("installations").getParam("causal_to_upload")},
          {"name":"autoUnload","value":false},
          {"name":"type_document","value":DocumentsType.DDT},
          {"name":"id_type","value":DocumentMode.buy},
          {"name":"description","value":""},
          {"name":"origin","value":"SERIALS"},
          {"name":"enableInventory","value":"SERIALS"},
          
          
          {"name":"private","value":1}],(instanceBilling)=>{
          if(instanceBilling!=null){
            this.reset();
            
          }
        });
  }
}